module.exports = __webpack_public_path__ + "img/certification-denominacion.4f426b2b.png";